var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('img',{class:_vm.$style.icon,attrs:{"src":require("./icon.png")}}),_vm._t("default"),_c('img',{class:_vm.$style.icon,attrs:{"src":require("./icon.png")}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }